export function slugify(str: string) {
  return str.toLowerCase().replace(/ /g, '-').replace(/\//g, '%2F');
}
